import type { BranchDeliverySystemType } from '../enums/BranchDeliverySystemType'
import type { BranchSegmentEntity } from './BranchSegmentEntity'
import type { AmountPerVehicleTypeEntity } from './AmountPerVehicleTypeEntity'
import type { DeliverySystemType } from '../enums/DeliverySystemType'

export class BranchDeliverySettingEntity {
  branchId?: number
  name?: string | null
  type?: DeliverySystemType
  valueType?: BranchDeliverySystemType
  perDirectDistance?: {
    amountPerKm?: number
    amountPerVehicleTypes?: AmountPerVehicleTypeEntity[]
  }
  perDirectDistanceSegment?: {
    segments?: BranchSegmentEntity[]
  }
}
